import { useCallback, useState } from "react";

/** Minimum time the list skeleton stays visible so the UI does not flash. */
export const LIST_SKELETON_MIN_MS = 250;

/**
 * Shared list-fetch loading state for voucher list pages.
 * Keeps the page interactive (no full-screen splash) while data loads.
 */
export function useListLoading(initialLoading = true) {
  const [isListLoading, setIsListLoading] = useState(initialLoading);

  const runListLoad = useCallback(
    async <T,>(fn: () => Promise<T>): Promise<T | undefined> => {
      const start = Date.now();
      setIsListLoading(true);
      try {
        return await fn();
      } finally {
        const remaining = Math.max(
          0,
          LIST_SKELETON_MIN_MS - (Date.now() - start)
        );
        if (remaining > 0) {
          await new Promise((r) => setTimeout(r, remaining));
        }
        setIsListLoading(false);
      }
    },
    []
  );

  return { isListLoading, setIsListLoading, runListLoad };
}
